import React, { useContext, useEffect, useState } from "react";
import "./Why_Choose.css";
import { Context } from "../../../utils/context";
import { whyChoose } from "../../../utils/apis/AboutUs/AboutUs";

const Why_Choose = () => {
  const data = [
    {
      icon: "/assets/images/about-us/ikon-1.png",
      title: "Affordable Pricing",
      desc:
        "Lorem Ipsum is simply dummy text of the printing & typesetting industry.",
    },
    {
      icon: "/assets/images/about-us/ikon-2.png",
      title: "Best Services",
      desc:
        "Lorem Ipsum is simply dummy text of the printing & typesetting industry.",
    },
    {
      icon: "/assets/images/about-us/ikon-3.png",
      title: "Coverage",
      desc:
        "Lorem Ipsum is simply dummy text of the printing & typesetting industry.",
    },
  ];


  const {
    IMG_URL,
  } = useContext(Context);

  const [whyChooseUs, setWhyChoose] = useState();
  const getAllWhyChoose = async () => {
    const res = await whyChoose();

    if (res?.success) {
      setWhyChoose(res?.data);
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }

  useEffect(() => {
    getAllWhyChoose();
  }, []);
  return (
    <section className="Why_Choose">
      <div className="container">
        <h2 className="section_title text-center">Why Choose Us?</h2>

        <div className="row mt-4 align-items-center">
          {whyChooseUs?.slice(0, 3).map((item, index) => (
            <div className="col-lg-4 col-md-6 col-sm-6 mb-3" key={index}>
              <div className="choose_card">

                <div className="icon_box">
                  <img src={IMG_URL + item.image} alt={item?.name} className="item_icon" />
                </div>

                <div className="content_box">
                  <h5 className="content_title">{item?.name}</h5>
                  <p className="content_desc">{item?.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Why_Choose;
